import { render, staticRenderFns } from "./TopNavbar.vue?vue&type=template&id=2084b384&scoped=true"
import script from "./TopNavbar.vue?vue&type=script&lang=ts"
export * from "./TopNavbar.vue?vue&type=script&lang=ts"
import style0 from "./TopNavbar.vue?vue&type=style&index=0&id=2084b384&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2084b384",
  null
  
)

export default component.exports